import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Snippet from "../snippet.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`This is the simplest way to get PostHog up and running. It only takes a few minutes.`}</p>
    <p>{`Copy the snippet below and replace `}<inlineCode parentName="p">{`<ph_project_api_key>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<ph_instance_address>`}</inlineCode>{` with your project's values, then add it within the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tags at the base of your product - ideally just before the closing `}<inlineCode parentName="p">{`</head>`}</inlineCode>{` tag. This ensures PostHog loads on any page users visit.`}</p>
    <p>{`You can find the snippet pre-filled with this data in `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project#snippet"
      }}>{`your project settings`}</a>{`.`}</p>
    <Snippet mdxType="Snippet" />
    <p>{`Once the snippet is added, PostHog automatically captures `}<inlineCode parentName="p">{`$pageview`}</inlineCode>{` and `}<a parentName="p" {...{
        "href": "/docs/data/autocapture"
      }}>{`other events`}</a>{` like button clicks. You can then enable other products, such as session replays, within `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings"
      }}>{`your project settings`}</a>{`. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      